import React from 'react';
import { Drawer, Descriptions, Tag } from 'antd';
import { GeoRule } from './types';
import { formatDateTime } from '../../utils/format';

interface RuleDetailsDrawerProps {
  rule: GeoRule | null;
  open: boolean;
  onClose: () => void;
}

const SCOPE_COLORS: Record<string, string> = {
  ip: 'geekblue',
  cidr: 'purple',
  account: 'orange',
  country: 'cyan',
};

export const RuleDetailsDrawer: React.FC<RuleDetailsDrawerProps> = ({
  rule,
  open,
  onClose,
}) => {
  if (!rule) {
    return null;
  }

  return (
    <Drawer
      title="Geo Rule Details"
      placement="right"
      width={480}
      onClose={onClose}
      open={open}
    >
      <Descriptions column={1} bordered size="middle">
        <Descriptions.Item label="ID">{rule.id}</Descriptions.Item>
        <Descriptions.Item label="Name">{rule.name}</Descriptions.Item>
        <Descriptions.Item label="Scope">
          <Tag color={SCOPE_COLORS[rule.scope] || 'default'}>
            {rule.scope.toUpperCase()}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Value">
          <code className="bg-slate-100 px-1 py-0.5 rounded font-mono text-sm">
            {rule.value}
          </code>
        </Descriptions.Item>
        <Descriptions.Item label="Action">
          <Tag color={rule.action === 'allow' ? 'green' : 'red'}>
            {rule.action.toUpperCase()}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Priority">{rule.priority}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={rule.status === 'active' ? 'blue' : 'default'}>
            {rule.status.toUpperCase()}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDateTime(rule.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDateTime(rule.updated_at)}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
};
